import { render, staticRenderFns } from "./CadastroRotaEtqs.vue?vue&type=template&id=34467e20&"
import script from "./CadastroRotaEtqs.vue?vue&type=script&lang=js&"
export * from "./CadastroRotaEtqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports